import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resendemail-confirmation',
  templateUrl: './resendemail-confirmation.component.html',
  styleUrls: ['./resendemail-confirmation.component.scss']
})
export class ResendemailConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
